import React from 'react';

const Transcation = () => {
  return (
    <div>Transcation</div>
  )
}

export default Transcation;